import { render, staticRenderFns } from "./MagisterForm.vue?vue&type=template&id=c2afd574&scoped=true"
import script from "./MagisterForm.vue?vue&type=script&lang=js"
export * from "./MagisterForm.vue?vue&type=script&lang=js"
import style0 from "./MagisterForm.vue?vue&type=style&index=0&id=c2afd574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2afd574",
  null
  
)

export default component.exports